export const DoodleArrow = ({ className = "" }) => (
  <svg viewBox="0 0 120 80" fill="none" className={className} aria-hidden="true">
    <path
      className="doodle-path"
      d="M8 12 C 40 60, 70 66, 100 44 M 88 34 L 102 45 L 86 54"
      stroke="#2B0A4E"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DoodleSparkle = ({ className = "" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <path
      className="doodle-path"
      d="M20 4 L20 36 M4 20 L36 20 M9 9 L31 31 M31 9 L9 31"
      stroke="#2B0A4E"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);

export const DoodleUnderline = ({ className = "" }) => (
  <svg viewBox="0 0 220 16" fill="none" className={className} aria-hidden="true" preserveAspectRatio="none">
    <path
      className="doodle-path"
      d="M4 10 C 50 4, 120 14, 216 7"
      stroke="#F2C230"
      strokeWidth="7"
      strokeLinecap="round"
    />
  </svg>
);

export const CatMark = ({ className = "" }) => (
  <img src="/assets/logo-cat.png" alt="KATZYA cat" className={className} draggable="false" />
);
